
<div class="ed-hero">
  <div class="container">
    <div class="grid">
      <div class="cell s12 m6">
        <div class="ed-domain">
          <h1>{{ context.config.name }}</h1>
          <p i18n>Diese Domain wird verkauft - Nutzen Sie diese Chance!</p>
        </div>
      </div>
      <div class="cell s12 m6">
        <div class="ed-purchase ed-panel">
          @if (showForm) {
            <app-contactform [context]="context"/>
          } @else {
            <div class="ed-preview" >
              <div class="ed-domain">{{ context.config.name }}</div>
              <p i18n>Schlagen Sie zu, bevor es jemand anderes tut!</p>

              @if (context.config.price) {
                <div class="ed-price">
                  <app-price [amount]="context.config.price"/>
                  <app-tax-note [type]="context.user.paynow.price_type"/>
                </div>
              }

              @if (context.user.paynow.public_phone) {
                <div class="ed-note">
                  <h2 i18n>Telefonnummer des Inhabers</h2>
                  <p>{{ context.user.paynow.public_phone }}</p>
                </div>
              }
              <div edButton (click)="showForm = true" i18n>
                Kontakt zum Inhaber aufnehmen
              </div>
              <div class="ed-usps">
                @for (usp of usps; track usp.text) {
                  <div class="ed-usp">
                    <app-icon>{{ usp.icon }}</app-icon>
                    <div [innerHTML]="usp.text"></div>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="ed-verified">
          <app-icon>verified_user</app-icon>
          <a class="e--link-plain" href="https://elitedomains.de/" target="_blank" i18n>Verifiziert durch ELITEDOMAINS</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ed-content-block-section" *ngIf="context.config.template_data['individual-content--text']">
  <div class="container">
    <app-content-block
      [content]="{
        headline: context.config.template_data['individual-content--headline'],
        text: context.config.template_data['individual-content--text'],
      }"
    />
  </div>
</div>

<div class="ed-steps">
  <div class="container">
    <div class="grid">
      <div class="cell s12 m5">
        <img ngSrc="/assets/landingpage/4sale/expert/steps-graphic.jpg" alt="Steps" height="555" width="450">
      </div>
      <div class="cell s12 m7">
        <h2 i18n>So kaufen Sie eine Domain direkt beim Inhaber</h2>
        <div class="ed-steps-frame">
          @for (faq of PurchaseDomainFaqQuestions; track faq.headline) {
            <div class="ed-step">
              <div class="ed-step-number">{{ $index + 1 }}</div>
              <div class="ed-step-content">
                <div class="ed-step-content">
                  <h3>{{ faq.headline }}</h3>
                  <p>{{ faq.description }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ed-facts">
  <h2 style="display: none" i18n>Vorteile einer Premium-Domain</h2>
  <div class="container">
    <div class="ed-panel">
      <div class="grid">
        <div class="cell s12 m4">
          <div class="ed-fact">
            <app-icon>highlight</app-icon>
            <h3 i18n>Höhere Sichtbarkeit</h3>
            <p i18n>Durch eine gute Domain erhalten Sie sofort mehr Sichtbarkeit und damit mehr Besucher und am Ende mehr Umsatz für Ihre Firma.</p>
          </div>
        </div>
        <div class="cell s12 m4">
          <div class="ed-fact">
            <app-icon>sentiment_satisfied</app-icon>
            <h3 i18n>Mehr Kundenvertrauen</h3>
            <p i18n>Eine schöne Domain mit einer seriösen Endung schaft sehr viel Vertrauen bei Kunden und Stakeholdern.</p>
          </div>
        </div>
        <div class="cell s12 m4">
          <div class="ed-fact">
            <app-icon>euro_symbol</app-icon>
            <h3 i18n>Niedrigere Marketingkosten</h3>
            <p i18n>Geringere Marketingkosten durch einen besseren Quality-Score, eine einfache Merkbarkeit und einen allgemeinen Branding-Effekt.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ed-faqs">
  <div class="container">
    <div class="grid">
      <div class="cell s12 m4">
        <div class="ed-topics">
          <div class="ed-topic ed--head" i18n>Häufige Fragen und Antworten</div>
          @for (group of faqGroups; track group.title) {
            <div
              (click)="currGroup = group"
              class="ed-topic ed--item"
              [ngClass]="{'ed--active': currGroup.icon === group.icon}"
            >
              <app-icon>{{ group.icon }}</app-icon>
              {{ group.title }}
            </div>
          }
        </div>
      </div>
      <div class="cell s12 m8">
        <app-accordion [entries]="currGroup.questions" />
      </div>
    </div>
  </div>
</div>

<footer>
  <div class="container">
    <div class="ed-inner">
      <app-i18n-selector/>
      <div class="ed-content">
        <div i18n>
          Die Domain {{ context.config.name }} wird auf diesem
          <a [href]="context.links.marketplace|userToken|safe" target="_blank">Domain Marktplatz</a>
          angeboten. Über dieses Formular kann entweder ein Angebot zum Kauf der Domain abgeben oder der
          Verantwortliche direkt kontaktiert werden. Alle Anfragen werden durch die kostenlose Technologie zum
          <a [href]="context.links.promo_sell_domains|userToken|safe" target="_blank">Domains verkaufen</a>
          automatisiert an den Inhaber weitergeleitet.
        </div>
        <div class="eg-bottom">
          <div class="ed-copyright">&copy;
            {{ year }}
            elitedomains.de
          </div>
          <a [routerLink]="['/impressum']" rel="nofollow" class="ed-imprint" target="_blank" i18n>
            Impressum
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
